import ManualVoucherRedemption from './ManualVoucherRedemption'

export default ManualVoucherRedemption
